import fetch from '@ixigo/fetch';

export type Offer = {
	id: number;
	banner: string;
	url: string;
	offerTitle: string;
	offerCode?: string;
	tnc?: string;
	clickActionOnDeal?: string;
};

export type HomepageOffer = {
	tag: string;
	deals: Offer[];
	isDefaultSelected?: boolean;
};

type OffersData = {
	homepage: HomepageOffer[];
};

type OffersResponse = {
	message: string;
	data: OffersData;
};

export const fetchOffers = async () => {
	try {
		const res = await fetch
			.get<OffersResponse>('upahaar-inventory/api/deals', {
				searchParams: {
					productType: 'CABS',
					source: 'HOMEPAGE',
					isProductOnly: 'true',
				},
			})
			.json();
		return res;
	} catch {
		return null;
	}
};
